import BlockRoundedIcon from '@mui/icons-material/BlockRounded'
import { Stack, Typography } from '@mui/material'

/**
 * SA-8 (Sección 18) — mismo mensaje neutral en toda la app, sin
 * "upgrade to Pro"/"contact sales" (no existe copy comercial aprobado
 * todavía) y sin cargar ningún dato del módulo (Sección 17).
 */
export function ModuleUnavailable() {
  return (
    <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ minHeight: '60vh', textAlign: 'center' }}>
      <BlockRoundedIcon sx={{ fontSize: 40, color: 'text.disabled' }} />
      <Typography variant="h6">Módulo no habilitado</Typography>
      <Typography variant="body2" color="text.secondary">
        Este módulo no está habilitado para tu organización.
      </Typography>
    </Stack>
  )
}
